/** @format */

import React from "react";
import { Row, Col, Container, Card, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import SignInForm from "./user-sign-in-form";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { useSelector } from "react-redux";
import * as SettingSelector from "../../../../store/setting/selectors";

import userlogin from "src/assets/images/user/FL(userloginpage).jpeg";
import logo from "src/assets/images/logo-FirstLink.png";

import icon1 from "src/assets/images/icon/sensor_occupied_24dp_E8EAED.png";
import icon2 from "src/assets/images/icon/devices_24dp_E8EAED.png";
import icon3 from "src/assets/images/icon/insert_link_24dp_E8EAED.png";
import icon4 from "src/assets/images/icon/manage_search_24dp_E8EAED.png";
import icon5 from "src/assets/images/icon/maps_ugc_24dp_E8EAED.png";
import icon6 from "src/assets/images/icon/person_add_24dp_E8EAED.png";
import icon7 from "src/assets/images/icon/podcasts_24dp_E8EAED.png";
import icon8 from "src/assets/images/icon/manage_search_24dp_E8EAED.png";
import UserSignUpForm from "./user-sign-up-form";

SwiperCore.use([Navigation, Autoplay]);

const UserSignUp = () => {
  const appName = useSelector(SettingSelector.app_name);
  const icons = [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8];

  return (
    <section className="sign-in-page">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} className="overflow-hidden position-relative">
            <div className="bg-success w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
            <div className="container-inside z-1">
              <div className="main-circle circle-small"></div>
              <div className="main-circle circle-medium"></div>
              <div className="main-circle circle-large"></div>
              <div className="main-circle circle-xlarge"></div>
              <div className="main-circle circle-xxlarge"></div>
            </div>

            <div className="sign-in-detail container-inside-top d-flex justify-content-center align-items-center">
              <Card
                className="p-0 border-0 rounded-circle overflow-hidden d-flex justify-content-center align-items-center"
                style={{
                  width: "320px",
                  height: "320px",
                  top: "-2%",
                  left: "0%",
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                <img
                  src={userlogin}
                  alt="User Login"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Card>

              {/* Icons */}
              {icons.map((icon, index) => {
                const angle = (index / icons.length) * 2 * Math.PI;
                const x = 260 * Math.cos(angle);
                const y = 260 * Math.sin(angle);
                return (
                  <div
                    key={index}
                    className="position-absolute"
                    style={{
                      top: `calc(47% + ${y}px)`,
                      left: `calc(50% + ${x}px)`,
                      transform: "translate(-50%, -50%)",
                      width: "70px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                      border: "2px solid #ffffff",
                      borderRadius: "100%",
                      padding: "4px",
                    }}
                  >
                    <img
                      src={icon}
                      alt={`icon${index + 1}`}
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                );
              })}

              {/* Lines */}
              {icons.map((_, index) => {
                const angle1 = (index / icons.length) * 2 * Math.PI;
                const angle2 =
                  (((index + icons.length / 2) % icons.length) / icons.length) *
                  2 *
                  Math.PI;
                const x1 = 280 * Math.cos(angle1);
                const y1 = 280 * Math.sin(angle1);
                const x2 = 280 * Math.cos(angle2);
                const y2 = 280 * Math.sin(angle2);

                return (
                  <div
                    key={index}
                    className="position-absolute line"
                    style={{
                      top: "58%",
                      left: "50%",
                      width: "1px",
                      height: "220px",
                      backgroundColor: "#FFFFFF",
                      transform: `translate(-50%, -50%) rotate(${Math.atan2(
                        y2 - y1,
                        x2 - x1
                      )}rad)`,
                      transformOrigin: "0 0",
                    }}
                  />
                );
              })}
            </div>
          </Col>

          <Col md={6}>
            <div className="sign-in-from text-center">
              <Link
                to="/"
                className="d-inline-flex align-items-center justify-content-center gap-2"
              >
                <img
                  src={logo}
                  alt="FirstLink Logo"
                  style={{ width: "210px", height: "auto" }}
                />
                <Badge
                  bg="success"
                  className="mt-2"
                  style={{ fontSize: "1rem" }}
                >
                  User
                </Badge>
              </Link>
              <p className="mt-3 font-size-16">
                Welcome to FirstLinks, a platform to connect with
                <br /> the social world
              </p>
              <UserSignUpForm />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UserSignUp;
